import FormikSwitchField from './FormikSwitchField';

export default FormikSwitchField;
